// extracted by mini-css-extract-plugin
module.exports = {"loader":"desktopRightLoader_loader__H5CYt"};